"use client";

import { useMemo } from "react";
import { useRouter } from "next/navigation";
import { useLocale } from "next-intl";
import { localizeRouter } from "@/lib/locale-href";

/**
 * `next/navigation`'s router with `push`/`replace` pointed at the CURRENT
 * locale's URL. Pass UNPREFIXED hrefs (`/search?q=x`, never `/vi/search`), the
 * prefix is added here, exactly as `LocaleLink` does for links.
 *
 * `useLocale()` is context-based and static-safe (no `usePathname`), so a
 * component using this stays prerenderable; see `LocaleLink` for why that
 * matters on `[slug]` routes.
 */
export function useLocaleRouter() {
  const router = useRouter();
  const locale = useLocale();
  return useMemo(() => localizeRouter(router, locale), [router, locale]);
}
